import { SentryUtils } from './SentryUtils'

export class CSRF {
  public static getToken(): string {
    return SentryUtils.expect<string>($('meta[name="csrf-token"]').attr('content'))
  }
}
